import { getResourceName } from 'features/resources'
import { reduxApiClient } from 'infra'
import { Button, Label, TextInput, Typography } from 'procyon-ui'
import React, { useState } from 'react'
import { enqueueNotification } from 'Utils/Helpers'
import { FullScreenContentModal, LoadingFeedback } from 'V2Components'

export function EditIntegrationModal({ integ, onCancel }) {
  const [webhookURL, setWebhookURL] = useState(integ.Spec?.WebhookUrl || '')
  const [isUpdating, setIsUpdating] = useState(false)

  const handleSaveIntegration = async () => {
    try {
      setIsUpdating(true)
      const newInteg = structuredClone(integ)
      newInteg.Spec.WebhookUrl = webhookURL
      console.log('newInteg', newInteg)
      await reduxApiClient('slackintegrations').update(newInteg)
      enqueueNotification('Integration updated successfully!', 'info')
      onCancel?.()
    } catch (error) {
      enqueueNotification('Error updating integration. Please try again.', 'error')
    } finally {
      setIsUpdating(false)
    }
  }

  const getError = () => {
    if (webhookURL.trim() === '') return 'Webhook URL cannot be empty'
    try {
      new URL(webhookURL)
    } catch (error) {
      return 'Please enter a valid URL'
    }
    return ''
  }

  const error = getError()

  return (
    <FullScreenContentModal>
      <div className='mb-4'>
        <Typography variant='h4-medium'>
          Edit <strong>{getResourceName(integ)}</strong>
        </Typography>
      </div>
      <div className='flex gap-2 items-center justify-center'>
        <TextInput
          sx={{ width: '100%' }}
          onChange={(e) => setWebhookURL(e.target.value)}
          label='Webhook URL'
          value={webhookURL}
        />
      </div>
      <div className='flex justify-end items-center gap-2 mt-4'>
        {error && <Label variant='warning' text={error} />}
        <Button onClick={onCancel} variant='gray'>
          Cancel
        </Button>
        <Button
          // disabled={webhookURL.trim() === integ.Spec?.WebhookUrl}
          onClick={handleSaveIntegration}
        >
          Update
        </Button>
      </div>
      {isUpdating && (
        <LoadingFeedback loading caption='Please wait...' message='Updating Integration' />
      )}
    </FullScreenContentModal>
  )
}
